document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("mobile-filter-button-muntex");

  if (toggleButton) {
    toggleButton.addEventListener("click", function () {
      // Get the nav element with class .n6as
      const nav = document.querySelector(".n6as");
      if (nav) {
        console.log("✅ Found nav with .n6as:", nav);
      } else {
        console.warn("⚠️ No nav with .n6as found");
      }

      // Remove 'toggle' class from all <ul><li>
      const allListItems = document.querySelectorAll("ul li");
      allListItems.forEach(function (li) {
        li.classList.remove("toggle");
      });

      console.log("🔘 Button clicked: li.toggle removed");
    });
  } else {
    console.warn("❌ Button #mobile-filter-button-muntex not found");
  }

  console.log("✅ custom-script.js loaded");
});
